import script from "./HotelSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelSearch.vue?vue&type=script&setup=true&lang=js"

import "./HotelSearch.vue?vue&type=style&index=0&id=bfb2d7dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfb2d7dc"]])

export default __exports__